export const checkIfLastNode = ({ id, edges }) => {
  const checkEdges = edges.find((edge) => edge.source === id);
  return checkEdges;
};
